import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromNotification from './notification.reducer';

/**
 * Every selector tolerates a missing feature slice (`state?.`). The header bell lives in the host
 * app and is mounted by specs and by projects that may not register `NotificationStoreModule`;
 * without the guard the first read would throw instead of reporting "no notifications". Mirrors
 * `condition.selectors`.
 */
export const selectNotificationState = createFeatureSelector<fromNotification.State>(
  fromNotification.notificationFeatureKey,
);

export const selectNotifications = createSelector(
  selectNotificationState,
  (state: fromNotification.State | undefined) => state?.notifications ?? [],
);

export const selectUnreadNotifications = createSelector(selectNotifications, (notifications) =>
  notifications.filter((n) => !n.read_at),
);

export const selectUnreadCount = createSelector(
  selectUnreadNotifications,
  (unread) => unread.length,
);

export const selectNotificationsLoaded = createSelector(
  selectNotificationState,
  (state: fromNotification.State | undefined) => state?.loaded ?? false,
);

export const selectNotificationsLoading = createSelector(
  selectNotificationState,
  (state: fromNotification.State | undefined) => state?.loading ?? false,
);

export const selectNotificationError = createSelector(
  selectNotificationState,
  (state: fromNotification.State | undefined) => state?.error ?? null,
);
